<page-content>
    <header-elitment header
            [hasSideMenu]="true">
    </header-elitment>
    <side-menu left-menu>
        <athlete-side-menu></athlete-side-menu>
    </side-menu>
    <error-401 *ngIf="is401"></error-401>
    <error-404 *ngIf="is404"></error-404>
    <module-content *ngIf="!is401 && !is404"
                    [title]="'AnnualPlanAthleteList'|translate:{athlete: athleteUser ? athleteUser.firstName + ' ' + athleteUser.lastName: ''}"
                    [mainActions]="mainActions">
        <div *ngIf="dataSource.count === 0" class="legend">{{ 'message.no_annual_plan_yet' | translate }}</div>
        <div class="search-bar">
            <mat-form-field [class.hidden]="dataSource.count == 0"
                            color="primary">
                <input matInput
                       type="text"
                       maxlength="255"
                       placeholder="{{ 'Filter' | translate }}"
                       #filterInput
                       (keyup)="onFilterKeyup(filterInput.value)">
                <mat-icon matSuffix>search</mat-icon>
            </mat-form-field>
        </div>
        <mat-table *ngIf="dataSource.count > 0"
                   [dataSource]="dataSource"
                   matSort
                   (matSortChange)="onSortChange($event)">
            <mat-header-row *matHeaderRowDef="columns"></mat-header-row>
            <mat-row *matRowDef="let row; columns: columns"></mat-row>

            <ng-container matColumnDef="title">
                <mat-header-cell *matHeaderCellDef class="name-cell">{{ 'Title' | translate }}</mat-header-cell>
                <mat-cell *matCellDef="let row; let i = index" class="name-cell">
                    <div><a [routerLink]="'/' + organization.code + '/athletes/' + this.athleteUser.id + '/plans/' + row.id">{{ row.title }}</a></div>
                </mat-cell>
            </ng-container>

            <ng-container matColumnDef="startedAt">
                <mat-header-cell *matHeaderCellDef class="name-cell">{{ 'StartedAt' | translate }}</mat-header-cell>
                <mat-cell *matCellDef="let row; let i = index" class="name-cell">
                    <div>{{ row.startedAtFirstWeekDay|appDate:'mediumDate' }}</div>
                </mat-cell>
            </ng-container>

            <ng-container matColumnDef="endedAt">
                <mat-header-cell *matHeaderCellDef class="name-cell">{{ 'EndedAt' | translate }}</mat-header-cell>
                <mat-cell *matCellDef="let row; let i = index" class="name-cell">
                    <div>{{ row.endedAtLastWeekDay|appDate:'mediumDate' }}</div>
                </mat-cell>
            </ng-container>

            <ng-container matColumnDef="creator">
                <mat-header-cell *matHeaderCellDef class="name-cell">{{ 'Created_by' | translate }}</mat-header-cell>
                <mat-cell *matCellDef="let row; let i = index" class="name-cell">
                    <div>{{ row.creator.firstName }} {{ row.creator.lastName }}</div>
                </mat-cell>
            </ng-container>

            <ng-container matColumnDef="isActive">
                <mat-header-cell *matHeaderCellDef mat-sort-header class="name-cell">{{ 'IsActive' | translate }}</mat-header-cell>
                <mat-cell *matCellDef="let row; let i = index" class="name-cell">
                    <i class="material-icons">
                        {{ (row.isActive) ? 'check' : 'close' }}
                    </i>
                </mat-cell>
            </ng-container>

            <ng-container matColumnDef="action">
                <mat-header-cell  mat-header-cell *matHeaderCellDef class="cell-right"></mat-header-cell>
                <mat-cell mat-cell *matCellDef="let row;  let i = index" class="cell-right">
                    <button
                        mat-icon-button
                        *ngIf="row.rights.active || row.rights.duplicate || row.rights.edit || row.rights.delete"
                        [matMenuTriggerFor]="menu">
                        <mat-icon>more_vert</mat-icon>
                    </button>
                    <mat-menu #menu="matMenu" xPosition="before">
                        <button
                            mat-menu-item
                            *ngIf="row.rights.active"
                            (click)="onMarkAsActiveClicked(row)">

                            <span *ngIf="!row.isActive"><mat-icon>check</mat-icon>&nbsp;{{ 'MarkAsActive' | translate }}</span>
                            <span *ngIf="row.isActive"><mat-icon>close</mat-icon>&nbsp;{{ 'MarkAsInactive' | translate }}</span>
                        </button>

                        <button
                            mat-menu-item
                            *ngIf="row.rights.duplicate"
                            (click)="onDuplicateClicked(row)">
                            <mat-icon>filter_none</mat-icon>&nbsp;
                            <span>{{ 'Duplicate' | translate }}</span>
                        </button>

                        <button
                            mat-menu-item
                            *ngIf="row.rights.edit"
                            (click)="onEditClicked(row)">
                            <mat-icon>edit_outlined</mat-icon>&nbsp;
                            <span>{{ 'Edit' | translate }}</span>
                        </button>
                        <button
                                mat-menu-item
                                *ngIf="row.rights.edit"
                                (click)="onDuplicateAsModel(row)">
                            <mat-icon>book</mat-icon>&nbsp;
                            <span>{{ 'Make_a_model' | translate }}</span>
                        </button>
                        <button
                            mat-menu-item
                            *ngIf="row.rights.delete"
                            (click)="onDeleteClicked(row)">
                            <mat-icon>delete</mat-icon>
                            <span>{{ 'Delete' | translate }}</span>
                        </button>
                    </mat-menu>
                </mat-cell>
            </ng-container>
        </mat-table>
        <mat-paginator [class.hidden]="dataSource.count == 0"
                       [pageSizeOptions]="[10]"
                       hidePageSize
                       showFirstLastButtons>
        </mat-paginator>
    </module-content>
    <div class="fab-right">
        <ng-container *ngIf="annualPlanRights.ADD">
            <main-action
                    [isLoading]="isLoading"
                    icon="add"
                    [disabled]="isLoading"
                    [matMenuTriggerFor]="menu"
            >
            </main-action>
            <mat-menu #menu="matMenu">
                <button mat-menu-item (click)="onAddClicked()">{{ 'NewAnnualPlan' | translate}}</button>
                <button mat-menu-item (mwlClick)="onImportClicked()">{{ 'ImportPlan' | translate }}</button>
            </mat-menu>
        </ng-container>
    </div>
</page-content>
